import { useFormik } from "formik";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { createFstUser } from "../../../apis/fstUsersApi";
import {
  MOBILE_COUNTRY_OPTIONS,
  getCallingCodeForCountry,
} from "../../../const/mobileCountryCodes";
import { createFstUserSchema } from "../../../Validations/fstUsersValidation";

const initialValues = {
  name: "",
  email: "",
  mobile: "",
  mobileCountryCode: "IE",
  mobileCountryCalling: "353",
  password: "",
  confirmPassword: "",
};

export default function AddFSTUser() {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("info");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues,
    validationSchema: createFstUserSchema,
    onSubmit: async (values) => {
      setMessage("");
      setLoading(true);
      try {
        const res = await createFstUser(values);
        if (res?.success) {
          formik.resetForm();
          navigate("/fst-users");
          return;
        }
        setMessageType("danger");
        setMessage(res?.message || "Failed to create FST user");
      } catch (error) {
        setMessageType("danger");
        setMessage("Error submitting form");
      } finally {
        setLoading(false);
      }
    },
  });

  const handleCountryChange = (e) => {
    const code = e.target.value;
    const calling = getCallingCodeForCountry(code);
    formik.setFieldValue("mobileCountryCode", code);
    formik.setFieldValue("mobileCountryCalling", calling);
  };

  const backClick = () => navigate("/fst-users");

  return (
    <div className="main-wrapper">
      <div className="page-wrapper">
        <div className="content container-fluid">
          <i
            className="fas fa-arrow-left"
            style={{ marginRight: "30px", fontSize: "20px", cursor: "pointer" }}
            onClick={backClick}
          />
          <div className="my-3 p-3 bg-body rounded shadow-sm">
            <h3>Add Viewer</h3>
            <style>
              {`
                .fst-password-field::-ms-reveal,
                .fst-password-field::-ms-clear {
                  display: none;
                }
              `}
            </style>
            <form onSubmit={formik.handleSubmit} className="formMaxwidth">
              <div className="input-block mb-3">
                <label className="col-form-label">
                  Name <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="name"
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.name && formik.errors.name && (
                  <span className="text-danger">{formik.errors.name}</span>
                )}
              </div>
              <div className="input-block mb-3">
                <label className="col-form-label">
                  Email <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="email"
                  name="email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.email && formik.errors.email && (
                  <span className="text-danger">{formik.errors.email}</span>
                )}
              </div>
              <div className="input-block mb-3">
                <label className="col-form-label">
                  Country <span className="text-danger">*</span>
                </label>
                <select
                  className="form-control"
                  name="mobileCountryCode"
                  value={formik.values.mobileCountryCode}
                  onChange={handleCountryChange}
                  onBlur={formik.handleBlur}
                >
                  {MOBILE_COUNTRY_OPTIONS.map((opt) => (
                    <option key={opt.code} value={opt.code}>
                      {opt.label}
                    </option>
                  ))}
                </select>
              </div>
              <div className="input-block mb-3">
                <label className="col-form-label">
                  Mobile <span className="text-danger">*</span>
                </label>
                <div className="input-group">
                  <span className="input-group-text">
                    +{formik.values.mobileCountryCalling}
                  </span>
                  <input
                    className="form-control"
                    type="text"
                    name="mobile"
                    value={formik.values.mobile}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>
                {formik.touched.mobile && formik.errors.mobile && (
                  <span className="text-danger">{formik.errors.mobile}</span>
                )}
              </div>
              <div className="input-block mb-3">
                <label className="col-form-label">
                  Password <span className="text-danger">*</span>
                </label>
                <div className="position-relative">
                  <input
                    className="form-control fst-password-field"
                    type={showPassword ? "text" : "password"}
                    name="password"
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    style={{ paddingRight: "40px" }}
                  />
                  <i
                    className={`fas ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
                    onClick={() => setShowPassword(!showPassword)}
                    style={{
                      position: "absolute",
                      right: "12px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "#6c757d",
                    }}
                    aria-label={
                      showPassword ? "Hide password" : "Show password"
                    }
                  />
                </div>
                {formik.touched.password && formik.errors.password && (
                  <span className="text-danger">{formik.errors.password}</span>
                )}
              </div>
              <div className="input-block mb-3">
                <label className="col-form-label">
                  Confirm Password <span className="text-danger">*</span>
                </label>
                <div className="position-relative">
                  <input
                    className="form-control fst-password-field"
                    type={showConfirmPassword ? "text" : "password"}
                    name="confirmPassword"
                    value={formik.values.confirmPassword}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    style={{ paddingRight: "40px" }}
                  />
                  <i
                    className={`fas ${
                      showConfirmPassword ? "fa-eye-slash" : "fa-eye"
                    }`}
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    style={{
                      position: "absolute",
                      right: "12px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "#6c757d",
                    }}
                    aria-label={
                      showConfirmPassword
                        ? "Hide confirm password"
                        : "Show confirm password"
                    }
                  />
                </div>
                {formik.touched.confirmPassword &&
                  formik.errors.confirmPassword && (
                    <span className="text-danger">
                      {formik.errors.confirmPassword}
                    </span>
                  )}
              </div>
              {loading ? (
                <div className="spinner-border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              ) : (
                <button className="btn btn-primary" type="submit">
                  Create Viewer
                </button>
              )}
            </form>
            {message && (
              <div className={`mt-3 alert alert-${messageType}`}>{message}</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
